import { PublicClientApplication } from '@azure/msal-browser';
import { msalB2CConfig } from 'services/b2cService';

const msalInstance = new PublicClientApplication(msalB2CConfig);

export default msalInstance;
